export const ADMIN_REGISTRATION_REQUEST = 'ADMIN_REGISTRATION_REQUEST';
export const ADMIN_REGISTRATION_SUCCESS = 'ADMIN_REGISTRATION_SUCCESS';
export const ADMIN_REGISTRATION_FAILURE = 'ADMIN_REGISTRATION_FAILURE';

export const USER_REGISTRATION_REQUEST = 'USER_REGISTRATION_REQUEST';
export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_FAILURE = 'USER_REGISTRATION_FAILURE';



export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';


export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const ADD_GROUPS = 'ADD_GROUPS';
export const GROUPS_LOADING = 'GROUPS_LOADING';
export const GROUPS_FAILED = 'GROUPS_FAILED';

export const JOIN_GROUP_REQUEST = 'JOIN_GROUP_REQUEST';
export const JOIN_GROUP_SUCCESS = 'JOIN_GROUP_SUCCESS';
export const JOIN_GROUP_FAILURE = 'JOIN_GROUP_FAILURE';

export const ACCEPT_JOIN_REQUEST = 'ACCEPT_JOIN_REQUEST';
export const ACCEPT_JOIN_SUCCESS = 'ACCEPT_JOIN_SUCCESS';
export const ACCEPT_JOIN_FAILURE = 'ACCEPT_JOIN_FAILURE';

export const REJECT_JOIN_REQUEST = 'REJECT_JOIN_REQUEST';
export const REJECT_JOIN_SUCCESS = 'REJECT_JOIN_SUCCESS';
export const REJECT_JOIN_FAILURE = 'REJECT_JOIN_FAILURE';


export const FETCH_GROUPS_REQUEST = 'FETCH_GROUPS_REQUEST';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE = 'FETCH_GROUPS_FAILURE';



export const FETCH_TESTS = ' FETCH_TESTS';
export const FETCH_TESTS_LOADING = 'FETCH_TESTS_LOADING';
export const FETCH_TESTS_FAILED = ' FETCH_TESTS_FAILED';

export const FETCH_TEST = 'FETCH_TEST';
export const FETCH_TEST_LOADING = 'FETCH_TEST_LOADING';
export const FETCH_TEST_FAILED = ' FETCH_TEST_FAILED';

export const SUBMIT_TEST = 'SUBMIT_TEST';